import { APIFetcher } from "@fetcher/fetcher";

const envVars = import.meta.env;

const VALORANT_API = new APIFetcher(
  `${envVars.VITE_API_HOST}${envVars.VITE_API_GROUP_ROUTES}/valorant`,
  "",
);

export default VALORANT_API;
